<template>
  <q-card flat bordered>
    <q-card-section class="q-pa-sm bg-primary">
      <div class="text-subtitle1 text-bold text-white">
        <q-icon name="paid" style="font-size: 25px; padding-right: 0.1rem" />
        Charged Today
      </div>
    </q-card-section>

    <q-separator />
    <q-card-section>
      <q-scroll-area style="height: 180px">
        <q-markup-table separator="cell" flat bordered dense>
          <thead>
            <tr class="text-center">
              <th class="text-left">Order</th>
              <th>Amount</th>
              <th class="text-right">Note</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in todayTransactions" v-bind:key="index">
              <td class="text-left">#{{ item.order.id }}</td>
              <td>{{ item.amount }}</td>
              <td class="text-right">{{ item.note }}</td>
            </tr>
            <tr class="text-center">
              <th class="text-left">Total</th>
              <th>{{ total }}</th>
              <th class="text-right"></th>
            </tr>
          </tbody>
        </q-markup-table>
      </q-scroll-area>
    </q-card-section>
  </q-card>
</template>

<script>
import graphql from '@client/graphql';

export default {
  apollo: {
    todayTransactions: {
      query: graphql.queries.getTodayTransactions
    }
  },
  computed: {
    total() {
      return this.todayTransactions?.reduce((a, item) => a + item.amount, 0);
    }
  }
};
</script>

<style></style>
